import missionWizardImage from '../../../../ui/assets/missionWizardImage.svg';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { FullScreenWizard } from '@juvare/common-form-ui/FullScreenWizard';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useEditMission } from '../hooks/useEditMission';
import { useMission } from '../hooks/useMission';
export const EditMission = () => {
    const { t } = useMissionsTranslation();
    const [changed, setChanged] = React.useState(false);
    const navigate = useNavigate();
    const { missionId } = useParams();
    const navigationContext = React.useContext(NavigationContext);
    const handleNavigateBack = () => navigationContext.navigate(() => navigate(-1));
    const { mission, isLoading } = useMission({ missionId, isVolunteerView: false });
    const { wizardConfig } = useEditMission({
        missionId: missionId,
        missionData: mission === null || mission === void 0 ? void 0 : mission.data,
    });
    const handleCancel = () => {
        if (changed) {
            showConfirmDialog({
                title: t('wizard.confirmWizardCloseTitle'),
                confirmLabel: t('wizard.closeWizardConfirmLabel'),
                cancelLabel: t('wizard.closeWizardCancelLabel'),
                content: React.createElement(Typography, { variant: 'body1' }, wizardConfig.closeWizardContent),
                onConfirm: () => {
                    navigationContext.clearChanged();
                    handleNavigateBack();
                },
            });
        }
        else {
            navigationContext.navigate(() => handleNavigateBack());
        }
    };
    const handleSubmitSuccess = () => {
        navigationContext.clearChanged();
        handleNavigateBack();
    };
    const handleChanged = React.useCallback((changed) => {
        if (changed) {
            navigationContext.setChanged(t('wizard.confirmWizardCloseTitle'));
        }
        else {
            navigationContext.clearChanged();
        }
        setChanged(changed);
    }, [t, navigationContext]);
    if (!mission || isLoading) {
        return React.createElement("div", null, t('common.loading'));
    }
    return (React.createElement(FullScreenWizard, { open: true, image: { src: missionWizardImage, alt: 'Edit Mission' }, title: wizardConfig.title, data: wizardConfig.data, steps: wizardConfig.steps, onCancel: handleCancel, onChanged: handleChanged, onSubmit: wizardConfig.onSubmit, onSubmitSuccess: handleSubmitSuccess }));
};
